import { render, staticRenderFns } from "./me.vue?vue&type=template&id=60ed1652&scoped=true&"
import script from "./me.vue?vue&type=script&lang=js&"
export * from "./me.vue?vue&type=script&lang=js&"
import style0 from "./me.vue?vue&type=style&index=0&id=60ed1652&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ed1652",
  null
  
)

export default component.exports